import { configureStore } from '@reduxjs/toolkit'
import userInfoReducer from './userInfoSlice'

export const store = configureStore({
  reducer: {
    userInfo: userInfoReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
